module.exports = __webpack_public_path__ + "static/img/role-cn.305409e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-4/role-cn.png
// module id = Ig/1
// module chunks = 1